import HttpService from './http.service.js'

export const setupAxiosInterceptors = (onUnauthenticated, onNotification) => {
  const onRequestSuccess = async config => {
    const token =
      localStorage.getItem('token') || sessionStorage.getItem('token')
    config.headers.Authorization = `Bearer ${token}`

    let fbpCookie = ''
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${'_fbp'}=`)
    if (parts.length === 2) fbpCookie = parts.pop().split(';').shift()

    config.headers.FBPCookie = fbpCookie

    return config
  }
  const onRequestFail = error => Promise.reject(error)

  HttpService.addRequestInterceptor(onRequestSuccess, onRequestFail)

  const onResponseSuccess = response => {
    if (response.data.notification) {
      if (response.data.notification_delay) {
        setTimeout(() => {
          onNotification(response.data.notification)
        }, response.data.notification_delay)
      } else {
        onNotification(response.data.notification)
      }
    }

    return response
  }

  const onResponseFail = error => {
    // console.log(error)
    // const status = error.status || error.response.status;
    // if (status === 403 || status === 401) {
    //   onUnauthenticated();
    // }

    onUnauthenticated()

    return Promise.reject(error)
  }
  HttpService.addResponseInterceptor(onResponseSuccess, onResponseFail)
}
